import { supabase } from './supabaseClient';

const ROUTE_MAP = {
  syncMonday: '/api/sync-monday',
  syncCalendars: '/api/sync-calendars',
  syncOneCalendar: '/api/sync-one-calendar',
  syncGrcSheet: '/api/sync-grc-sheet',
  googleOauthStatus: '/api/google-oauth-status',
  fetchColdcall: '/api/fetch-coldcall',
  fetchMondayProduction: '/api/fetch-monday-production',
  dailySnapshot: '/api/daily-snapshot',
  getLeads: '/api/get-leads',
  listCalendars: '/api/list-calendars',
  forceUpdateEvent: '/api/force-update-event',
  cleanupDupes: '/api/cleanup-dupes',
  dedupeCalendarEvents: '/api/dedupe-calendar-events',
  debugCalendarEvents: '/api/debug-calendar-events',
  debugParse: '/api/debug-parse',
  calendarWebhook: '/api/calendar-webhook',
};

function routeFor(name) {
  if (ROUTE_MAP[name]) return ROUTE_MAP[name];
  return '/api/' + name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export const functions = {
  async invoke(name, payload = {}) {
    const session = await supabase.auth.getSession();
    const token = session?.data?.session?.access_token;

    const res = await fetch(routeFor(name), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });

    let body = null;
    const contentType = res.headers.get('content-type') || '';
    try {
      body = contentType.includes('application/json')
        ? await res.json()
        : await res.text();
    } catch {
      body = null;
    }

    if (!res.ok) {
      const err = new Error(
        (body && (body.error || body.message)) ||
          `Function ${name} failed (${res.status})`
      );
      err.status = res.status;
      err.body = body;
      throw err;
    }
    // Wrap in { data } for Base44 SDK compat — many consumers read res.data.*
    return { data: body, status: res.status };
  },
};

export default functions;
